<div class="kal-datepicker__input">

  <kal-input icon="event_note"
             autocomplete="off"
             [label]="label"
             [placeholder]="placeholder"
             [formControl]="control"
             (iconClicked)="toggle()">
  </kal-input>

  <ng-template cdkPortal #datepickerCalendar="cdkPortal">
    <div class="kal-datepicker__calendar">
      <kal-calendar (datePicked)="setInputValue($event)"
                    [selectedDate]="selectedDate"
                    [validator]="parentControlValidator"
                    [maxYear]="maxYear"
                    [minYear]="minYear"></kal-calendar>

    </div>
  </ng-template>
</div>
